import { z } from "zod";

import { rowLessonsTypeSchema, updateLessonsTypeSchema } from "@libs/schemas";

import { activitySchema } from "./activity";
import { moduleSchema } from "./module";

export const lessonSchema = rowLessonsTypeSchema.merge(
  z.object({
    module: moduleSchema
      .pick({
        id: true,
        name: true,
        color: true,
      })
      .partial({
        color: true,
      })
      .optional(),
    activities: z
      .array(
        activitySchema.pick({
          id: true,
          name: true,
          type: true,
          duration: true,
          skills: true,
        }),
      )
      .optional()
      .catch([]),
  }),
);

export type LessonType = z.infer<typeof lessonSchema>;

export const updateLessonFormSchema = updateLessonsTypeSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type UpdateLessonFormType = z.infer<typeof updateLessonFormSchema>;

const lessonFilterSchema = z.object({
  search: z.string().optional().catch(""),
  moduleIds: z.array(z.string().uuid()).optional().catch([]),
  coursesIds: z.array(z.string().uuid()).optional().catch([]),
});
export type LessonFilterType = z.infer<typeof lessonFilterSchema>;

export const lessonSearchParamsSchema = lessonFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});
